import * as activityTypesList from './activityTypesList';

import {combineReducers} from "redux";
import {all, fork} from "redux-saga/effects";

export interface IState  {
    activityTypesList: activityTypesList.IState
}

export const ActionCreators = {
    activityTypesList: activityTypesList.ActionCreators,
}

export const Reducers = combineReducers<IState>({
    activityTypesList: activityTypesList.Reducers,
});

export function* sagas() {
    yield all([
        fork(activityTypesList.sagas),
    ]);
}

